export default "__VITE_ASSET__CwV2tVBR__"